// src/components/ConfirmarSessaoScreen.jsx

import React, { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

import Logo from "../assets/logo.png";
import "../sass/pages/confirmarSessao.scss";

const API_BASE = (
  process.env.REACT_APP_API_URL ||
  "https://api.psyassist.com.br"
).replace(/\/$/, "");

export default function ConfirmarSessaoScreen() {
  const [searchParams] = useSearchParams();
  const token = useMemo(
    () => String(searchParams.get("token") || "").trim(),
    [searchParams]
  );

  const [status, setStatus] = useState(
    token ? "ready" : "invalid"
  );
  const [message, setMessage] = useState(
    token
      ? "Confirme abaixo que você estará presente na sessão."
      : "O link de confirmação está incompleto."
  );

  const confirmar = async () => {
    if (!token || status === "loading") return;

    setStatus("loading");
    setMessage("Confirmando sua presença...");

    try {
      const response = await fetch(
        `${API_BASE}/psy/lembrete-sessao/confirmar/${encodeURIComponent(
          token
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data?.message ||
            data?.error ||
            "Não foi possível confirmar a presença."
        );
      }

      setStatus("success");
      setMessage(
        data?.message || "Presença confirmada com sucesso."
      );
    } catch (error) {
      setStatus("error");
      setMessage(
        error?.message ||
          "Não foi possível confirmar a presença."
      );
    }
  };

  return (
    <main className="cfs-page">
      <section className={`cfs-card cfs-card--${status}`}>
        <img src={Logo} alt="PsyAssist" className="cfs-logo" />

        <div className="cfs-icon" aria-hidden="true">
          {status === "success"
            ? "✓"
            : status === "error" || status === "invalid"
              ? "!"
              : "📅"}
        </div>

        <span className="cfs-kicker">Confirmação de sessão</span>
        <h1>
          {status === "success"
            ? "Presença confirmada"
            : status === "error" || status === "invalid"
              ? "Não foi possível confirmar"
              : "Você confirma sua presença?"}
        </h1>

        <p>{message}</p>

        {status === "ready" ? (
          <button type="button" onClick={confirmar}>
            Confirmar presença
          </button>
        ) : null}

        {status === "loading" ? (
          <button type="button" disabled>
            Confirmando...
          </button>
        ) : null}

        {status === "success" ? (
          <small>
            O profissional já pode visualizar sua confirmação na agenda.
          </small>
        ) : null}
      </section>
    </main>
  );
}
